import Form from "@components/shared/form";
import React, { ReactElement } from "react";
import styles from "./styles.module.scss";
import { DomainForm } from "src/api";
import { useDomainContext } from "@hooks/useDomainContext";
export const AllowedSlugsAuto = [
    "car-warranty",
    "autowarranty",
    "auto-warranty",
];
export const AllowedSlugsHome = ["home-warranty"];
export default function CategoryForm({
    form,
}: {
    form: DomainForm;
}): ReactElement {
    const { category } = useDomainContext();
    return (
        <div
            className={` ${
                AllowedSlugsHome.includes(category?.slug as string)
                    ? styles["mainSectionHome"]
                    : ""
            } ${
                AllowedSlugsAuto.includes(category?.slug as string)
                    ? styles["mainSectionCar"]
                    : ""
            }`}
        >
            <div>
                <Form
                    colors={{
                        primaryColor: "#478ff0",
                        progressBar: "grey",
                    }}
                    secondServiceColors={{
                        mainBackgroundColor: "#f1f6ff",
                        mainBorderColor: "#c5d4f4",
                        hoverRadioColor: "#4f96f6",
                        selectedRadioColor: "#4f96f6",
                        textHoverRadioColor: "#fff",
                        textSelectedRadioColor: "#fff",
                        hoverCheckboxColor: "#ddecff",
                        selectedCheckboxColor: "#ddecff",
                    }}
                    classes={{
                        formClassName: styles["form"],
                        formButtonClassName: styles["form-button"],
                        formStepInnerClassName: styles["form-inner"],
                        stepClassName: styles["step"],

                        fieldsClassName: {
                            radio: styles["radio-field"],
                            checkbox: styles["checkbox-field"],
                            all: styles["field"],
                        },
                        formFieldClassName: styles["field-wrapper"],
                        stepTitleClassName: styles["step-title"],
                        stepDescriptionClassName: styles["step-description"],
                        formProgressbarClassName: styles["progress-bar"],
                        labelAsTitleClassName: styles["label-as-step-title"],
                        tcpaClassName: styles["tcpa"],
                    }}
                    goToThankYouPage={
                        AllowedSlugsHome.includes(category?.slug as string)
                            ? false
                            : true
                    }
                    showProgress
                    form={form}
                    dynamicThankYouFields={[
                        "firstName",
                        "manufacturingYear",
                        "vehicleMake",
                        "vehicleModel",
                    ]}
                />
            </div>
        </div>
    );
}
